export default "__VITE_ASSET__ed94b35a__"